export default function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div
      className="overflow-hidden border-y border-charcoal/10 bg-cream py-5"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-fraunces text-3xl md:text-4xl italic font-light text-charcoal/90">
            {t}
            <span className="text-rust text-2xl not-italic">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
}
